import { render, staticRenderFns } from "./OpenInCatalogBrowse.vue?vue&type=template&id=183590b6&scoped=true"
import script from "./OpenInCatalogBrowse.vue?vue&type=script&lang=js"
export * from "./OpenInCatalogBrowse.vue?vue&type=script&lang=js"
import style0 from "./OpenInCatalogBrowse.vue?vue&type=style&index=0&id=183590b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183590b6",
  null
  
)

export default component.exports